import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'core-dashboard',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {

  widgets: Array<any> = [
  ];
  gridsterOptions = {
    lines: {
      visible: true,
      color: '#e0e0e0',
      width: 1
    },
    shrink: true,
    lanes: 2, // how many lines (grid cells) dashboard has
    direction: 'vertical', // items floating direction: vertical/horizontal/none
    floating: false, // default=true - prevents items to float according to the direction (gravity)
    dragAndDrop: true, // possible to change items position by drag n drop
    resizable: true, // possible to resize items by drag n drop by item edge/corner
    useCSSTransforms: true, // Uses CSS3 translate() instead of position top/left - significant performance boost.
    responsiveSizes: true, // allow to set different item sizes for different breakpoints
    // ResponsiveOptions can overwrite default configuration with any option available for specific breakpoint.
    responsiveOptions: [
      {
        breakpoint: 'sm',
        lanes: 2
      },
      {
        breakpoint: 'md',
        minWidth: 768,
        lanes: 6,
        dragAndDrop: true,
        resizable: true
      },
      {
        breakpoint: 'lg',
        lanes: 6,
        dragAndDrop: true,
        resizable: true
      },
      {
        breakpoint: 'xl',
        minWidth: 1800,
        lanes: 6,
        dragAndDrop: true,
        resizable: true
      }
    ]
  };

  constructor() {
  }

  ngOnInit() {
  }

}
